<template>
  <v-layout column class="pa-4">
    <v-card class="px-4 py-5 mb-4">
      <v-layout row :wrap="$vuetify.breakpoint.xs">
        <v-flex xs12 sm6 md4 lg3 xl2>
          <v-layout align-center column>
            <v-avatar :size="150" color="grey lighten-4" class="mb-3">
              <v-img :src="avatarUrl" alt="avatar"></v-img>
            </v-avatar>
            <p class="body-2 font-weight-regular primary--text text-xs-center">
              <b>Nome do Beneficiário</b>
              <br />
              {{ dadosBeneficiario.nome }}
            </p>
            <v-layout row>
              <v-btn
                flat
                small
                color="grey darken-2"
                class="body-2 text-none text-underline"
                @click="$refs.image.click()"
                >Alterar Foto</v-btn
              >
              <input
                type="file"
                style="display: none"
                @change="uploadImage"
                ref="image"
                accept="image/*"
              />
              <v-dialog v-model="dialogPassword" width="400">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    small
                    color="grey darken-2"
                    class="body-2 text-none text-underline"
                    v-on="on"
                    >Alterar Senha</v-btn
                  >
                </template>

                <v-card>
                  <v-card-title
                    class="headline primary white--text"
                    primary-title
                  >
                    Alterar Senha
                  </v-card-title>

                  <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field
                        name="senhaAtual"
                        label="Senha Atual"
                        type="password"
                        v-model="passwordData.senhaAtual"
                        :rules="passwordRules"
                        required
                        data-cy="senhaAtualField"
                      ></v-text-field>
                      <v-text-field
                        name="senha"
                        label="Senha"
                        type="password"
                        v-model="passwordData.senha"
                        required
                        :rules="passwordRules"
                        data-cy="senhaField"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      flat
                      :disabled="!valid"
                      @click="updatePassword"
                      data-cy="signinSubmitBtn"
                    >
                      Salvar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout column>
            <v-container v-bind="{ [`grid-list-md`]: true }" fluid>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 lg12 xl12>
                  <h1
                    class="subheading font-weight-bold primary--text mb-5"
                    :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
                  >
                    Dados do Beneficiário
                  </h1>
                </v-flex>
                <v-flex xs12 sm12 md6 lg4 xl2>
                  <p
                    class="body-2 font-weight-regular grey--text text--darken-2"
                    :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
                  >
                    <b>Número do Cartão</b>
                    <br />
                    {{ dadosBeneficiario.numeroCartao }}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md6 lg4 xl2>
                  <p
                    class="body-2 font-weight-regular grey--text text--darken-2"
                    :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
                  >
                    <b>Cartão Nacional de Saúde</b>
                    <br />
                    {{ dadosBeneficiario.cns }}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md6 lg4 xl2>
                  <p
                    class="body-2 font-weight-regular grey--text text--darken-2"
                    :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
                  >
                    <b>Número de Identificação do Plano</b>
                    <br />
                    {{ dadosBeneficiario.planoRegistroAns }}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md6 lg4 xl2>
                  <p
                    class="body-2 font-weight-regular grey--text text--darken-2"
                    :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
                  >
                    <b>Nome do Plano</b>
                    <br />
                    {{ dadosBeneficiario.planoNomeComercial }}
                  </p>
                </v-flex>
              </v-layout>
            </v-container>
            <v-layout align-center justify-end row>
              <v-btn
                light
                :color="highContrast ? 'white' : 'primary'"
                class="mr-4"
                @click="logout()"
                >LOGOUT/SAIR</v-btn
              >
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import auth from "./login/auth";

import { getAvatar, updateAvatar, updatePassword } from "@/services/usuario";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "Profile",
  computed: {
    ...beneficiarioStore.mapState(["avatarUrl", "dadosBeneficiario"]),
    ...portalStore.mapState(["highContrast", "usuario"])
  },
  data() {
    return {
      dialog: false,
      dialogPassword: false,
      valid: false,
      passwordData: {
        senha: "",
        senhaAtual: ""
      },
      passwordRules: [
        v => !!v || "A senha é obrigatória",
        v => v.length >= 8 || "A senha deve ser maior do que 8 caracteres"
      ]
    };
  },
  methods: {
    ...portalStore.mapMutations(["setToast"]),
    logout() {
      auth.logout({}, this.$store, this.$router);
    },
    updatePassword() {
      if (this.$refs.form.validate()) {
        const data = {
          ...this.passwordData,
          codigoBeneficiario: this.dadosBeneficiario.id.replace(/\D/g, ""),
          dataNascimento: this.dadosBeneficiario.dataNascimento,
          usuarioId: this.usuario.id
        };

        updatePassword(data)
          .then(() => {
            this.passwordData.senha = "";
            this.passwordData.senhaAtual = "";
            this.setToast("Senha alterada com sucesso!");
            this.dialogPassword = false;
          })
          .catch(({ response }) => {
            const error = response?.data;
            const message = error.message
              ? error.message
              : error.errors?.map(error => error.message)[0];

            this.setToast(message);
          });
      }
    },
    uploadImage(e) {
      let img = e.target.files[0];
      let fd = new FormData();
      fd.append("file", img);
      updateAvatar(fd)
        .then(() => {
          getAvatar(this.$store);
        })
        .catch(({ response }) => {
          const error = response?.data;
          const message = error.message
            ? error.message
            : error.errors?.map(error => error.message)[0];

          this.setToast(message);
        });
    }
  }
};
</script>

<style scoped>
.text-underline {
  text-decoration: underline;
}
</style>
